const RDPD_TABLE_SUB_HEADERS = [
    { label: 'FIRST NAME',      key: 'firstName', },
    { label: 'MIDDLE NAME',     key: 'middleName',  },
    { label: 'LAST NAME',       key: 'lastName',  },
    { label: 'PHONE NUMBER',    key: 'phoneNumber',  },
    { label: 'EMAIL',           key: 'email', },
    { label: 'DISTRIBUTOR TYPE',    key: 'distributorType',  },
    { label: 'STATUS',          key: 'status',  },
    { label: 'ASSIGNED BY',    key: 'assignedBy',  },
    { label: 'ASSIGNED DATE',            key: 'assignedDate',  },
    { label: 'MODIFIED BY',    key: 'modifiedBy',  },
    { label: 'MODIFIED DATE',            key: 'modifyDate',  },
    { label: 'ACTIONS', centered: true, sortable: false},
];

const VIEW_RDPD_TABLE_SUB_HEADERS = [
    { label: 'FIRST NAME',      key: 'firstName', },
    { label: 'MIDDLE NAME',     key: 'middleName',  },
    { label: 'LAST NAME',       key: 'lastName',  },
    { label: 'PHONE NUMBER',    key: 'phoneNumber',  },
    { label: 'EMAIL',           key: 'email', },
    { label: 'ASSIGNED BY',    key: 'assignedBy',  },
    { label: 'ASSIGNED DATE',  key: 'assignedDate',  },
];

const VIEW_RDPD_TABLE_SUB_HEADERS_NON_SORTABLE = [
    { label: 'FIRST NAME',      centered: true, sortable: false },
    { label: 'MIDDLE NAME',    centered: true, sortable: false },
    { label: 'LAST NAME',      centered: true, sortable: false },
    { label: 'PHONE NUMBER',    centered: true, sortable: false },
    { label: 'EMAIL',           centered: true, sortable: false },
    { label: 'ASSIGNED BY',    centered: true, sortable: false },
    { label: 'ASSIGNED DATE', centered: true, sortable: false }
];



const STATUS_OPTIONS = [
    { label: 'Enabled',  value: 0 },
    { label: 'Disabled', value: 1 },
];

const DISTRIBUTOR_TYPE_OPTIONS = [
    { label: 'RD',     value: 'RD' },
    { label: 'PD', value: 'PD' },
    { label: 'RT', value: 'RT' },
];

export {
    RDPD_TABLE_SUB_HEADERS,
    VIEW_RDPD_TABLE_SUB_HEADERS,
    VIEW_RDPD_TABLE_SUB_HEADERS_NON_SORTABLE,
    DISTRIBUTOR_TYPE_OPTIONS,
    STATUS_OPTIONS
}



